import avatarModule from '../avatarModule';

function avatarScalingPlaceholder(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarScalingPlaceholder
  };
}

avatarModule.directive('avatarScalingPlaceholder', avatarScalingPlaceholder);

export default avatarScalingPlaceholder;
